export type SourceId = "ifood" | "carrefour" | "supernosso" | "villefort";

export const ALL_SOURCES: SourceId[] = [
  "ifood",
  "carrefour",
  "supernosso",
  "villefort",
];

export const SOURCE_LABELS: Record<SourceId, string> = {
  ifood: "iFood",
  carrefour: "Carrefour",
  supernosso: "Supernosso",
  villefort: "Villefort",
};

export interface NormalizedProduct {
  id: string;
  source: SourceId;
  merchantName: string;
  name: string;
  price: number;
  listPrice: number;
  imageUrl: string | null;
  link: string | null;
  brand: string | null;
  available: boolean;
  unitPrice: { value: number; unit: string } | null;
}

export interface SourceResult {
  products: NormalizedProduct[];
  error: string | null;
  fetchedAt: number;
}

export interface SearchResults {
  term: string;
  results: Record<SourceId, SourceResult>;
}

export interface ShoppingListItem {
  id: string;
  searchTerm: string;
  primary: NormalizedProduct;
  matches: Partial<Record<SourceId, NormalizedProduct | null>>;
}

export interface BulkSearchResponse {
  items: ShoppingListItem[];
  terms: string[];
  skipped: string[];
}
